import React from 'react';
import { CompanyRow } from './CompanyRow';
import { LibraryIcon } from 'lucide-react';
const companies = [{
  id: 1,
  name: 'SurveyMonkey',
  logo: '🐵',
  accountType: 'Prospect',
  sequenceStage: 'Step 3: Product overview email',
  revenue: '$500 mil. - $1 bil.',
  propensityScore: 83,
  propensityColor: 'orange',
  trafficVisits: 9623
}, {
  id: 2,
  name: 'MongoDB',
  logo: '🍃',
  accountType: 'Former Customer',
  sequenceStage: 'Step 5: Meeting follow-up call',
  revenue: '$1 bil. - $5 bil.',
  propensityScore: 90,
  propensityColor: 'green',
  trafficVisits: 9045
}, {
  id: 3,
  name: 'Starburst',
  logo: '⭐',
  accountType: 'Prospect',
  sequenceStage: 'Step 2: Initial call attempt',
  revenue: '$100 mil. - $250 mil.',
  propensityScore: 60,
  propensityColor: 'orange',
  trafficVisits: 8342
}, {
  id: 4,
  name: 'Kaseya',
  logo: '🔷',
  accountType: 'Prospect',
  sequenceStage: 'Step 4: Case study email',
  revenue: '$500 mil. - $1 bil.',
  propensityScore: 44,
  propensityColor: 'orange',
  trafficVisits: 8565
}, {
  id: 5,
  name: 'SentinelOne',
  logo: '🛡️',
  accountType: 'Prospect',
  sequenceStage: 'Step 1: Intro email',
  revenue: '$500 mil. - $1 bil.',
  propensityScore: 28,
  propensityColor: 'red',
  trafficVisits: 8867
}, {
  id: 6,
  name: 'Geotab',
  logo: '🌐',
  accountType: 'Former Customer',
  sequenceStage: 'Step 6: Re-engagement attempt',
  revenue: '$500 mil. - $1 bil.',
  propensityScore: 30,
  propensityColor: 'red',
  trafficVisits: 8467
}, {
  id: 7,
  name: 'Freshworks',
  logo: '🌈',
  accountType: 'Former Customer',
  sequenceStage: 'Not enrolled',
  revenue: '$500 mil. - $1 bil.',
  propensityScore: 77,
  propensityColor: 'orange',
  trafficVisits: 6566
}, {
  id: 8,
  name: 'Indeed',
  logo: 'ℹ️',
  accountType: 'Prospect',
  sequenceStage: 'Step 2: Value prop follow-up',
  revenue: '$1 bil. - $5 bil.',
  propensityScore: 80,
  propensityColor: 'green',
  trafficVisits: 7436
}, {
  id: 9,
  name: 'Seismic',
  logo: '🌊',
  accountType: 'Customer',
  sequenceStage: 'Sequence completed',
  revenue: '$250 mil. - $500 mil.',
  propensityScore: 19,
  propensityColor: 'red',
  trafficVisits: 9233
}];
interface GTMStudioTableProps {
  onOpenLibrary: () => void;
}
export function GTMStudioTable({
  onOpenLibrary
}: GTMStudioTableProps) {
  return <div className="w-full h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100" data-id="element-1262">
      {/* Header */}
      <div className="border-b border-gray-200 bg-white/80 backdrop-blur-sm px-4 lg:px-6 py-3 lg:py-4 flex items-center justify-between shadow-sm" data-id="element-1263">
        <div className="flex items-center gap-2 lg:gap-3" data-id="element-1264">
          <div className="w-6 h-6 lg:w-8 lg:h-8 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center text-white font-bold text-xs lg:text-sm shadow-md" data-id="element-1265">
            Z
          </div>
          <h1 className="text-lg lg:text-xl font-semibold text-gray-900" data-id="element-1266">
            GTM Studio
          </h1>
        </div>
        <button onClick={onOpenLibrary} className="flex items-center gap-2 px-3 lg:px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 transition-all duration-200 text-sm shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-1267">
          <LibraryIcon className="w-4 h-4" data-id="element-1268" />
          <span className="hidden sm:inline" data-id="element-1269">GTM Plays Library</span>
          <span className="sm:hidden" data-id="element-1270">Plays</span>
        </button>
      </div>
      {/* Desktop Table View */}
      <div className="hidden lg:block flex-1 overflow-auto" data-id="element-1271">
        <table className="w-full" data-id="element-1272">
          <thead className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 sticky top-0 shadow-sm" data-id="element-1273">
            <tr data-id="element-1274">
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1275">
                <div className="flex items-center gap-2" data-id="element-1276">
                  <span className="w-5 h-5 bg-gradient-to-br from-red-600 to-red-700 rounded flex items-center justify-center text-white text-xs shadow-sm" data-id="element-1277">
                    Z
                  </span>
                  Company
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1278">
                <div className="flex items-center gap-2" data-id="element-1279">
                  <span className="text-blue-500" data-id="element-1280">☁️</span>
                  Account Type
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1281">
                <div className="flex items-center gap-2" data-id="element-1282">
                  <span data-id="element-1283">S</span>
                  Sequence Stage
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1284">
                <div className="flex items-center gap-2" data-id="element-1285">
                  <span className="w-5 h-5 bg-gradient-to-br from-red-600 to-red-700 rounded flex items-center justify-center text-white text-xs shadow-sm" data-id="element-1286">
                    Z
                  </span>
                  Revenue
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1287">
                <div className="flex items-center gap-2" data-id="element-1288">
                  <span className="text-blue-400" data-id="element-1289">❄️</span>
                  Purchase Propensity Score
                </div>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1290">
                <div className="flex items-center gap-2" data-id="element-1291">
                  <span className="text-red-500" data-id="element-1292">🔴</span>
                  Traffic Visits
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100" data-id="element-1293">
            {companies.map(company => <CompanyRow key={company.id} company={company} data-id="element-1294" />)}
          </tbody>
        </table>
      </div>
      {/* Mobile Card View */}
      <div className="lg:hidden flex-1 overflow-auto p-4 space-y-4" data-id="element-1295">
        {companies.map(company => <div key={company.id} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-200" data-id="element-1296">
            <div className="flex items-center gap-3 mb-3" data-id="element-1297">
              <div className="text-2xl" data-id="element-1298">{company.logo}</div>
              <div className="flex-1" data-id="element-1299">
                <h3 className="font-semibold text-gray-900" data-id="element-1300">{company.name}</h3>
                <p className="text-xs text-gray-600" data-id="element-1301">{company.accountType}</p>
              </div>
            </div>
            <div className="space-y-2 text-sm" data-id="element-1302">
              <div className="flex justify-between" data-id="element-1303">
                <span className="text-gray-600" data-id="element-1304">Sequence:</span>
                <span className="text-gray-900 text-right" data-id="element-1305">
                  {company.sequenceStage}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-1306">
                <span className="text-gray-600" data-id="element-1307">Revenue:</span>
                <span className="text-gray-900" data-id="element-1308">{company.revenue}</span>
              </div>
              <div className="flex justify-between" data-id="element-1309">
                <span className="text-gray-600" data-id="element-1310">Propensity:</span>
                <span className={`font-semibold ${company.propensityColor === 'green' ? 'text-green-600' : company.propensityColor === 'orange' ? 'text-orange-600' : 'text-red-600'}`} data-id="element-1311">
                  {company.propensityScore}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-1312">
                <span className="text-gray-600" data-id="element-1313">Traffic:</span>
                <span className="text-gray-900" data-id="element-1314">
                  {company.trafficVisits.toLocaleString()}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}